module.exports = __webpack_public_path__ + "assets/img/qiwi.d9628214.svg";